module.exports = __webpack_public_path__ + "img/emops.e1454e6b.png";